/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { SelectField, SelectOption } from '@coursera/cds-core';

import { filterOptions } from 'bundles/degree-home/components/v2/Calendar';
import type { FilterOptionValuesType } from 'bundles/degree-home/components/v2/Calendar/constants/constants';
import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';

import _t from 'i18n!nls/degree-home';

export const getFilterLabel = (value: FilterOptionValuesType) => {
  switch (value) {
    case 'all':
      return _t('All (Deadlines + Live Events)');
    case 'deadlines':
      return _t('Deadlines');
    case 'liveEvents':
      return _t('Live Events');
    case 'overdue':
      return _t('Overdue');
    default:
      return '';
  }
};

export const CalendarFilter: React.FunctionComponent<{ mobile?: boolean }> = ({ mobile }) => {
  const { filter, setFilter, refetchCalendarItems, refetchRequired, setRefetchRequired } = useDegreeContext();
  const e2ePrefix = mobile ? 'mobile-' : '';

  return (
    <div
      css={css`
        width: calc(100% - 58px);
        margin: 0 auto 16px auto;

        > div {
          width: 100%;
          max-width: none;
        }

        label {
          display: none;
        }
      `}
    >
      <SelectField
        data-e2e={`${e2ePrefix}calendar-filter`}
        label={_t('Filter by')}
        value={filter}
        onChange={(event) => {
          setFilter(event.target.value as FilterOptionValuesType);
          if (refetchRequired) {
            refetchCalendarItems();
            setRefetchRequired(false);
          }
        }}
      >
        {filterOptions.map((option) => (
          <SelectOption key={option} value={option}>
            {getFilterLabel(option)}
          </SelectOption>
        ))}
      </SelectField>
    </div>
  );
};
